if (!window.moz) {
  requestAnimationFrame(() => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (!customElements.get('sticky-sidebar')) {
        customElements.define('sticky-sidebar',
          class StickySidebar extends HTMLElement {
            constructor() {
              super();
            }

            connectedCallback() {
              this.onUpdate = this.update.bind(this);

              ['throttle30fpsResize', 'MutationObserver', 'updateStickySidebar']
              .forEach(event => window.addEventListener(event, this.onUpdate));
            }

            disconnectedCallback() {
              ['throttle30fpsResize', 'MutationObserver', 'updateStickySidebar']
              .forEach(event => window.removeEventListener(event, this.onUpdate));
            }

            update() {
              if (!themeBase.isDesktop) {
                return;
              }
              if (this.isFreezeScrollEnable !== themeBase.isFreezeScrollEnable) {
                this.style.setProperty('--sticky-freeze-top', themeBase.isFreezeScrollEnable ? `${(getLogicalRect(this).top - getLogicalRect(this.parentNode).top) / 10}rem` : '');
                this.isFreezeScrollEnable = themeBase.isFreezeScrollEnable;
              }
              if (themeBase.isFreezeScrollEnable) {
                return;
              }

              const height = themeBounds.get(this).height;
              let offsetTop = 0;

              try {
                offsetTop = eval(getComputedStyle(this).getPropertyValue('--sticky-top').replace(/[a-z]/g, '')) * 10;
              } catch (error) {
                log(error);
              }

              if (height > themeBase.windowHeight - offsetTop) {
                this.style.setProperty('--sticky-current-height', `${Math.floor(height) / 10 * -1}rem`);
                this.classList.add('sticky-sidebar--dynamic-offset');
              } else {
                this.classList.remove('sticky-sidebar--dynamic-offset');
              }
            }
          }
        );
      }
    });
  });
}